import axios from 'axios';

// Create an axios instance with the base URL
const api = axios.create({
    // baseURL: 'https://admin.banglaconstruction.store/api',
    baseURL: 'https://nzbd.websolutionfirm.com/api',
    // baseURL: 'http://127.0.0.1:8000/api',
});

export default api;